import { render, staticRenderFns } from "./ItemOptionsReorder.vue?vue&type=template&id=cb70eafc&scoped=true&"
import script from "./ItemOptionsReorder.vue?vue&type=script&lang=js&"
export * from "./ItemOptionsReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb70eafc",
  null
  
)

export default component.exports